module.exports = __webpack_public_path__ + "img/gglogo.129d321d.png";